import { render } from "./testimonials-four.vue?vue&type=template&id=243dee66"
import script from "./testimonials-four.vue?vue&type=script&lang=js"
export * from "./testimonials-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__